import api from '@/utils/api'
import Vue from 'vue'
import {hrS} from '@/components/shared/vue.globals'

let NodesMixin = {
  methods: {
    nodeIsImage (node) {
      return node.extension === 'jpg' || node.extension === 'jpeg' || node.extension === 'png' || node.extension === 'gif' || node.extension === 'bmp'
    },
    nodeIsAudio (node) {
      return node.extension === 'mp3'
    },
    nodeIsLink (node) {
      return node.extension === ':link'
    },
    nodeIsPDF (node) {
      return node.extension === 'pdf'
    },
    nodeIsYoutubeLink (node) {
      return node.extension === ':youtube'
    },
    nodeIsDownloadable (node) {
      return node.extension !== void 0 && node.extension[0] !== ':'
    },
    nodeIsPrintable (node) {
      return this.nodeIsImage(node) || this.nodeIsPDF(node)
    },
    hasNotPreviewImage (node) {
      var _ref
      return !((_ref = node.extension) === 'jpg' || _ref === 'jpeg' || _ref === 'png' || _ref === 'gif' || _ref === ':youtube' || _ref === ':vimeo')
    },
    getNodeYoutubeLink (node) {
      return 'https://www.youtube.com/embed/' + node.url
    },
    getNodeYoutubeImageLink (node) {
      return 'https://img.youtube.com/vi/' + node.url + '/mqdefault.jpg'
    },
    getNodeYoutubeExternalLink (node) {
      return 'https://www.youtube.com/watch?v=' + node.url
    },
    downloadLink (node, size) {
      if (!size) {
        size = 3
      }
      let param = '&' + api.getLastTokenUrlParam()
      return process.env.apiBaseUrl + 'file/' + node.id + '/download?size=' + size + param
    },
    downloadLinkReactive (node, size) {
      var downloaderLink = new Vue({
        data: {
          baseUrl: process.env.apiBaseUrl + 'file/' + node.id + '/download?size=' + size,
          tokenParam: api.getLastTokenUrlParam(),
          isReady: false
        },
        computed: {
          url () {
            return this.baseUrl + '&' + this.tokenParam
          }
        }
      })
      api.getTokenUrlParam().then((tokenParam) => {
        downloaderLink.tokenParam = tokenParam
        downloaderLink.isReady = true
      })
      return downloaderLink
    },
    hrS
  },
  filters: {
    nodeIconClass (node) {
      if (node.kind === 'folder') {
        return 'fa-folder-o'
      }
      if (node.extension === 'jpg' || node.extension === 'jpeg' || node.extension === 'png' || node.extension === 'gif') {
        return 'fa-picture-o'
      }
      if (node.extension === 'mp4') {
        return 'fa-video-camera'
      }
      if (node.extension === 'mp3') {
        return 'fa-music'
      }
      if (node.extension === 'pdf') {
        return 'fa-file-pdf-o'
      }
      if (node.extension === 'txt') {
        return 'fa-file-text-o'
      }
      if (node.extension === 'html' || node.extension === 'js' || node.extension === 'css' || node.extension === 'sass' || node.extension === 'less' || node.extension === 'coffee') {
        return 'fa-file-code-o'
      }
      if (node.extension === 'xls' || node.extension === 'xlsx') {
        return 'fa-file-excel-o'
      }
      if (node.extension === 'ppt' || node.extension === 'pptx') {
        return 'fa-file-powerpoint-o'
      }
      if (node.extension === 'doc' || node.extension === 'docx' || node.extension === 'odt') {
        return 'fa-file-word-o'
      }
      if (node.extension === 'zip' || node.extension === '7z' || node.extension === 'rar') {
        return 'fa-file-archive-o'
      }
      if (node.url !== null) {
        return 'fa-link'
      }
      return 'fa-file-o'
    }
  }
}
export default NodesMixin



// WEBPACK FOOTER //
// ./src/components/shared/NodeMixin.js